import { ProductsRootView } from "./views";

export const routes: Spintr.ISpintrRoute[] = [
    { path: "/products", component: ProductsRootView },
];

export const adminRoutes: Spintr.ISpintrRoute[] = [
    { path: "/admin/products", component: ProductsRootView },
];
